/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type SplitPositionParameters2 = {
  unlockedLiquidityNumerator: number;
  permanentLockedLiquidityNumerator: number;
  feeANumerator: number;
  feeBNumerator: number;
  reward0Numerator: number;
  reward1Numerator: number;
};

export type SplitPositionParameters2Args = SplitPositionParameters2;

export function getSplitPositionParameters2Encoder(): FixedSizeEncoder<SplitPositionParameters2Args> {
  return getStructEncoder([
    ["unlockedLiquidityNumerator", getU32Encoder()],
    ["permanentLockedLiquidityNumerator", getU32Encoder()],
    ["feeANumerator", getU32Encoder()],
    ["feeBNumerator", getU32Encoder()],
    ["reward0Numerator", getU32Encoder()],
    ["reward1Numerator", getU32Encoder()],
  ]);
}

export function getSplitPositionParameters2Decoder(): FixedSizeDecoder<SplitPositionParameters2> {
  return getStructDecoder([
    ["unlockedLiquidityNumerator", getU32Decoder()],
    ["permanentLockedLiquidityNumerator", getU32Decoder()],
    ["feeANumerator", getU32Decoder()],
    ["feeBNumerator", getU32Decoder()],
    ["reward0Numerator", getU32Decoder()],
    ["reward1Numerator", getU32Decoder()],
  ]);
}

export function getSplitPositionParameters2Codec(): FixedSizeCodec<
  SplitPositionParameters2Args,
  SplitPositionParameters2
> {
  return combineCodec(
    getSplitPositionParameters2Encoder(),
    getSplitPositionParameters2Decoder(),
  );
}
